import React, { useEffect, useState } from "react";
import logo from "../../assets/images/BuildTrust-white.png";
import { imageDefaultPrefixPath } from "../../config";
import { checkIfFileExists } from "../../pages/common/Misc";
import { useNavigate } from "react-router-dom";

const Sitelogo = () => {
  // const role = localStorage.getItem("role");
  const roleType = localStorage.getItem("roleType");
  const [accountingFirmLogo, setAccountingFirmLogo] = useState("");
  const profile = localStorage.getItem("bt-accounting-firm-logo")
    ? localStorage.getItem("bt-accounting-firm-logo")
    : "";
  const token = localStorage.getItem("bt-auth-token");
  const navigate = useNavigate();

  useEffect(() => {
    if (profile) {
      checkIfFileExists(`${imageDefaultPrefixPath}${profile}`, (exists) => {
        if (exists) {
          setAccountingFirmLogo(`${imageDefaultPrefixPath}${profile}`);
        } else {
          setAccountingFirmLogo();
        }
      });
    }
  }, [profile]);

  return (
    <div className="sitelogo">
      <img
        src={logo}
        alt="BuildTrust"
        style={{
          maxWidth: "500px",
          filter: "brightness(100)",
          cursor: "pointer",
        }}
        onClick={() =>
          roleType === "Builder"
            ? navigate("/projects")
            : (roleType === "Accounting Firm" || roleType === "Contact")
            ? navigate("/builders")
            : roleType === "Admin" && navigate("/admin-dashboard")
        }
      />
      { roleType === "Contact" && <span>Beta</span>}
      {token &&
        roleType !== "Client" &&
        roleType !== "Admin" &&
        profile &&
        accountingFirmLogo && (
          <div className="ac-branding-logo">
            <img src={accountingFirmLogo} alt="" className="ac-firm-logo" />
          </div>
        )}
    </div>
  );
};

export default Sitelogo;
